// apiUtils.ts
import { getUserContext } from './userContextManager';
import { getSignedRequest } from '../utils/IAMAuthUtils';

/**
 * Make an authenticated API request
 */
export const makeApiRequest = async (
    baseUrl: string,
    method: string,
    path: string,
    requestBody?: any
) => {
    try {
        // Get user context
        const userContext = await getUserContext();

        // Get signed request
        const signedRequest = await getSignedRequest(baseUrl, method, path, userContext, requestBody);

        // Build fetch options
        const fetchOptions: RequestInit = {
            method: signedRequest.method,
            headers: signedRequest.headers,
        };

        // Only include body if method allows it
        if (
            signedRequest.method !== 'GET' &&
            signedRequest.method !== 'HEAD' &&
            signedRequest.body
        ) {
            fetchOptions.body = signedRequest.body;
        }

        // Send request
        const response = await fetch(signedRequest.url, fetchOptions);

        /*if (!response.ok) {
            throw new Error(`API request failed: ${response.status}`);
        }*/

        return response;
    } catch (error) {
        console.error('API request failed:', error);
        throw error;
    }
};
